module.exports = __webpack_public_path__ + "img/hyj9.9bc6ec48.png";